// Variantes reutilizables de Framer Motion para todo el sitio

export const easeLux = [0.22, 1, 0.36, 1];

// Reveal genérico de secciones al hacer scroll
export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: easeLux },
  },
};

export const fade = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 1, ease: easeLux } },
};

// Contenedor para stagger de hijos
export const stagger = (delayChildren = 0, staggerChildren = 0.12) => ({
  hidden: {},
  show: {
    transition: { delayChildren, staggerChildren },
  },
});

// Revelado tipo máscara: la línea sube desde abajo
export const maskLine = {
  hidden: { y: "110%" },
  show: {
    y: "0%",
    transition: { duration: 1, ease: easeLux },
  },
};

export const scaleImg = {
  hidden: { scale: 1.15, opacity: 0 },
  show: { scale: 1, opacity: 1, transition: { duration: 1.2, ease: easeLux } },
};
